import "./Loader.css";

const equations = [
  "x² + y² = r²",
  "a² + b² = c²",
  "E = mc²",
  "π = 3.14159",
  "e = 2.71828",
  "sin²θ + cos²θ = 1",
  "∫₀¹ x² dx",
  "Σn = n(n+1)/2",
  "√625 = 25",
  "12 × 12 = 144",
  "2⁸ = 256",
  "5! = 120",
  "Δ = b² − 4ac",
  "y = mx + c",
  "f(x)",
  "log₂64 = 6",
  "∞",
  "7³ = 343",
  "lim x→∞",
  "πr²",
];

const calculations = [
  "sin²θ + cos²θ = 1",
  "∫₀¹ x² dx",
  "Σn = n(n+1)/2",
  "log₂64 = 6",
  "∞",
  "lim x→∞",
  "πr²",
];

const loadingMessages = [
  "Preparing data...",
  "Loading tables...",
  "Calculating progress...",
  "Thinking...",
  "Almost ready...",
];

export default function Loader() {
  return (
    <div className="education-loader">
      {/* Floating Background */}
      <div className="floating-elements">
        {equations.map((eq, index) => (
          <span
            key={index}
            className="equation"
            style={{
              left: `${5 + ((index * 17) % 90)}%`,
              top: `${5 + ((index * 31) % 90)}%`,
              animationDelay: `${index * 0.8}s`,
              animationDuration: `${18 + (index % 6) * 2}s`,
              fontSize: `${20 + (index % 4) * 6}px`,
            }}
          >
            {eq}
          </span>
        ))}
      </div>

      {/* Tiny Particles */}
      <div className="particles">
        {Array.from({ length: 40 }).map((_, i) => (
          <span
            key={i}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${12 + Math.random() * 10}s`,
            }}
          />
        ))}
      </div>

      <div className="loader-card">
        <div className="math-spinner">
          <span>+</span>
          <span>−</span>
          <span>×</span>
          <span>÷</span>
        </div>

        <div className="number-counter">
          <div className="number-track">
            {calculations.map((calc, i) => (
              <span key={i}>{calc}</span>
            ))}
          </div>
        </div>

        <div className="loading-text">
          <div className="message-track">
            {loadingMessages.map((msg, i) => (
              <span key={i}>{msg}</span>
            ))}
          </div>
        </div>

        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
